module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The information given in this edition of the Yearbook of Astronomy is in narrative form. The positions of the planets given in the Monthly Sky Notes often refer to the constellations in which they lie at the time. These can be found on the star charts which collectively show the whole sky via two charts depicting the northern and southern circumpolar stars and forty-eight charts depicting the main stars and constellations for each month of the year. The northern and southern circumpolar charts show the stars that are within 45° of the two celestial poles, while the monthly charts depict the stars and constellations that are visible throughout the year from Europe and North America or from Australia and New Zealand. The monthly charts overlap the circumpolar charts. Wherever you are on the Earth, you will be able to locate and identify the stars depicted on the appropriate areas of the chart(s).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are numerous star atlases available that offer more detailed information, such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sky & Telescope’s POCKET SKY ATLAS")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Norton’s STAR ATLAS and Reference Handbook")]), _vm._v(" to name but a couple. In addition, more precise information relating to planetary positions and so on can be found in a number of publications, a good example of which is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Handbook of the British Astronomical Association")]), _vm._v(", as well as many of the popular astronomy magazines such as the British monthly periodicals "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sky at Night")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Astronomy Now")]), _vm._v(" and the American monthly magazines "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Astronomy")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sky & Telescope")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ad515ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Preface.vue
// module id = 75
// module chunks = 0